<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <card-store-summary/>
      </v-col>
      <v-col cols="12">
        <card-asin-summary/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardStoreSummary from "@/page/Dashboard/CardStoreSummary";
import CardAsinSummary from "@/page/Dashboard/CardAsinSummary";



export default {
  name: "Dashboard",
  components: {
    CardAsinSummary,
    CardStoreSummary,
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped>
</style>